import { getErrorMessage, getMaxAllowedSlots, getSeasonCodeSuffix, SEASON_FAMILY } from '../../utils';
import {
  REQUEST_BOOKING_SEARCH,
  RECEIVE_BOOKING_SEARCH,
  SET_BOOKING_SEARCH_FAILURE,
  CLEAR_BOOKING_SEARCH_ERROR_MESSAGE,
  SET_BOOKING_DATA_FROM_COOKIE,
  SET_BOOKING_SEARCH_LOGIN_DENIED,
  REQUEST_BOOKING_BALANCE,
  RECEIVE_BOOKING_BALANCE,
  SET_BOOKING_BALANCE_FAILURE,
  SET_SHOW_APP_MODAL,
  SET_SITE_CODE,
} from '../constants/bookingSearch';

export const initialState = {
  isFetching: false,
  booking: {},
  isDaBooking: false,
  resId: 0,
  siteCode: '',
  lastName: '',
  arrivalDate: '',
  errorMessage: '',
  departureDate: '',
  mainGuestFirstName: '',
  numOfGuests: 0,
  numOfAdults: 0,
  numOfChildren: 0,
  numOfToddlers: 0,
  numOfInfants: 0,
  numOfUnits: 0,
  fullName: '',
  agencyType: '',
  isBookingDataSetFromCookies: false,
  maxAllowedShowBookingSlots: 0,
  secretCode: '',
  isEarlyAccess: false,
  seasonType: SEASON_FAMILY,
  seasonSuffix: '',
  showAppModal: false,
  isHbs: false,
};

const bookingSearch = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_BOOKING_SEARCH: {
      return { ...state, isFetching: true };
    }
    case RECEIVE_BOOKING_SEARCH: {
      const {
        booking,
        resId,
        siteCode,
        lastName,
        arrivalDate,
        departureDate,
        numOfGuests,
        mainGuestFirstName,
        numOfAdults,
        numOfChildren,
        numOfToddlers,
        numOfInfants,
        numOfUnits,
        fullName,
        agencyType,
        maxEntertainmentSlotsLessThan7Nights,
        maxEntertainmentSlotsMoreThanOrEqual7Nights,
        isDaBooking = false,
        secretCode,
        isEarlyAccess,
        seasonType,
        isHbs,
      } = action;
      return {
        ...state,
        isFetching: false,
        booking,
        errorMessage: '',
        resId,
        siteCode,
        lastName,
        arrivalDate,
        departureDate,
        numOfGuests,
        mainGuestFirstName,
        numOfAdults,
        numOfChildren,
        numOfToddlers,
        numOfInfants,
        numOfUnits,
        maxAllowedShowBookingSlots: getMaxAllowedSlots(
          arrivalDate,
          departureDate,
          maxEntertainmentSlotsLessThan7Nights,
          maxEntertainmentSlotsMoreThanOrEqual7Nights,
        ),
        fullName,
        isDaBooking,
        secretCode,
        isEarlyAccess,
        agencyType,
        seasonType,
        seasonSuffix: getSeasonCodeSuffix(seasonType),
        isHbs,
      };
    }
    case SET_BOOKING_SEARCH_FAILURE: {
      const { error } = action;
      const errorMessage = getErrorMessage(error, true);
      return { ...state, isFetching: false, errorMessage };
    }
    case CLEAR_BOOKING_SEARCH_ERROR_MESSAGE: {
      return { ...state, errorMessage: '' };
    }
    case SET_BOOKING_SEARCH_LOGIN_DENIED: {
      const { error } = action;
      return { ...state, isFetching: false, errorMessage: error };
    }
    case SET_BOOKING_DATA_FROM_COOKIE: {
      const {
        resId,
        siteCode,
        lastName,
        arrivalDate,
        departureDate,
        mainGuestFirstName,
        numOfGuests,
        numOfAdults,
        numOfChildren,
        numOfToddlers,
        numOfInfants,
        numOfUnits,
        fullName,
        maxEntertainmentSlotsLessThan7Nights,
        maxEntertainmentSlotsMoreThanOrEqual7Nights,
        isDaBooking,
        secretCode,
        isEarlyAccess,
        agencyType,
        seasonType,
        isHbs,
      } = action;
      return {
        ...state,
        resId: state.resId === 0 ? resId : state.resId,
        siteCode: state.siteCode === '' ? siteCode : state.siteCode,
        lastName: state.lastName === '' ? lastName : state.lastName,
        arrivalDate: state.arrivalDate === '' ? arrivalDate : state.arrivalDate,
        departureDate: state.departureDate === '' ? departureDate : state.departureDate,
        numOfGuests: state.numOfGuests === 0 ? numOfGuests : state.numOfGuests,
        mainGuestFirstName: state.mainGuestFirstName === '' ? mainGuestFirstName : state.mainGuestFirstName,
        numOfAdults: state.numOfAdults === 0 ? numOfAdults : state.numOfAdults,
        numOfChildren: state.numOfChildren === 0 ? numOfChildren : state.numOfChildren,
        numOfToddlers: state.numOfToddlers === 0 ? numOfToddlers : state.numOfToddlers,
        numOfInfants: state.numOfInfants === 0 ? numOfInfants : state.numOfInfants,
        numOfUnits: state.numOfUnits === 0 ? numOfUnits : state.numOfUnits,
        fullName: state.fullName === '' ? fullName : state.fullName,
        isBookingDataSetFromCookies: true,
        maxAllowedShowBookingSlots: getMaxAllowedSlots(
          arrivalDate,
          departureDate,
          maxEntertainmentSlotsLessThan7Nights,
          maxEntertainmentSlotsMoreThanOrEqual7Nights,
        ),
        isDaBooking,
        secretCode,
        isEarlyAccess,
        agencyType,
        seasonType,
        seasonSuffix: getSeasonCodeSuffix(seasonType),
        isHbs,
      };
    }
    case REQUEST_BOOKING_BALANCE: {
      return { ...state, isFetching: true };
    }
    case RECEIVE_BOOKING_BALANCE: {
      const { balance } = action;
      return { ...state, balance, isFetching: false };
    }
    case SET_BOOKING_BALANCE_FAILURE: {
      const { error, isLogin } = action;
      const errorMessage = getErrorMessage(error, isLogin);
      return { ...state, isFetching: false, errorMessage };
    }
    case SET_SHOW_APP_MODAL: {
      const { showAppModal } = action;
      return { ...state, showAppModal, isFetching: false };
    }
    case SET_SITE_CODE: {
      const { siteCode } = action;
      return { ...state, siteCode };
    }
    default:
      return state;
  }
};

export default bookingSearch;
